import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import MovieCard from '../components/Content/MovieCard';
import '../components/Content/Content.css';
import Title from '../components/common/Title';

// Sample movie data for browse page
const browseMovies = [
  {
    id: 7,
    title: 'The Godfather',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BM2MyNjYxNmUtYTAwNi00MTYxLWJmNWYtYzZlODY3ZTk3OTFlXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    rating: 9.2,
    year: 1972,
    genres: ['Drama', 'Crime'],
    description: 'The aging patriarch of an organized crime dynasty transfers control of his clandestine empire to his reluctant son.',
    trailerUrl: 'https://www.youtube.com/embed/sY1S34973zA'
  },
  {
    id: 8,
    title: 'Fight Club',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BMmEzNTkxYjQtZTc0MC00YTVjLTg5ZTEtZWMwOWVlYzY0NWIwXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    rating: 8.8,
    year: 1999,
    genres: ['Drama', 'Action'],
    description: 'An insomniac office worker and a devil-may-care soapmaker form an underground fight club that evolves into something much, much more.',
    trailerUrl: 'https://www.youtube.com/embed/SUXWAEX2jlg'
  },
  {
    id: 9,
    title: 'Forrest Gump',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BNWIwODRlZTUtY2U3ZS00Yzg1LWJhNzYtMmZiYmEyNmU1NjMzXkEyXkFqcGdeQXVyMTQxNzMzNDI@._V1_.jpg',
    rating: 8.8,
    year: 1994,
    genres: ['Drama', 'Comedy'],
    description: 'The presidencies of Kennedy and Johnson, the events of Vietnam, Watergate, and other historical events unfold through the perspective of an Alabama man with an IQ of 75.',
    trailerUrl: 'https://www.youtube.com/embed/bLvqoHBptjg'
  },
  {
    id: 10,
    title: 'The Lord of the Rings: The Fellowship of the Ring',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BN2EyZjM3NzUtNWUzMi00MTgxLWI0NTctMzY4M2VlOTdjZWRiXkEyXkFqcGdeQXVyNDUzOTQ5MjY@._V1_.jpg',
    rating: 8.8,
    year: 2001,
    genres: ['Action', 'Adventure', 'Sci-Fi'],
    description: 'A meek Hobbit from the Shire and eight companions set out on a journey to destroy the powerful One Ring and save Middle-earth from the Dark Lord Sauron.',
    trailerUrl: 'https://www.youtube.com/embed/V75dMMIW2B4'
  },
  {
    id: 11,
    title: 'The Silence of the Lambs',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BNjNhZTk0ZmEtNjJhMi00YzFlLWE1MmEtYzM1M2ZmMGMwMTU4XkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    rating: 8.6,
    year: 1991,
    genres: ['Horror', 'Thriller'],
    description: 'A young F.B.I. cadet must receive the help of an incarcerated and manipulative cannibal killer to help catch another serial killer, a madman who skins his victims.',
    trailerUrl: 'https://www.youtube.com/embed/W6Mm8Sbe__o'
  },
  {
    id: 12,
    title: 'The Departed',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTI1MTY2OTIxNV5BMl5BanBnXkFtZTYwNjQ4NjY3._V1_.jpg',
    rating: 8.5,
    year: 2006,
    genres: ['Drama', 'Crime', 'Thriller'],
    description: 'An undercover cop and a mole in the police attempt to identify each other while infiltrating an Irish gang in South Boston.',
    trailerUrl: 'https://www.youtube.com/embed/iojhqm0JTW4'
  },
  {
    id: 13,
    title: 'The Green Mile',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BMTUxMzQyNjA5MF5BMl5BanBnXkFtZTYwOTU2NTY3._V1_.jpg',
    rating: 8.6,
    year: 1999,
    genres: ['Drama', 'Fantasy'],
    description: 'The lives of guards on Death Row are affected by one of their charges: a black man accused of child murder and rape, yet who has a mysterious gift.',
    trailerUrl: 'https://www.youtube.com/embed/Ki4haFrqSrw'
  },
  {
    id: 14,
    title: 'Schindler\'s List',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BNDE4OTMxMTctNmRhYy00NWE2LTg3YzItYTk3M2UwOTU5Njg4XkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    rating: 9.0,
    year: 1993,
    genres: ['Drama', 'History', 'Documentary'],
    description: 'In German-occupied Poland during World War II, industrialist Oskar Schindler gradually becomes concerned for his Jewish workforce after witnessing their persecution by the Nazis.',
    trailerUrl: 'https://www.youtube.com/embed/gG22XNhtnoY'
  },
  {
    id: 15,
    title: 'Inception',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BMjAxMzY3NjcxNF5BMl5BanBnXkFtZTcwNTI5OTM0Mw@@._V1_.jpg',
    rating: 8.8,
    year: 2010,
    genres: ['Action', 'Sci-Fi', 'Thriller'],
    description: 'A thief who steals corporate secrets through the use of dream-sharing technology is given the inverse task of planting an idea into the mind of a C.E.O.',
    trailerUrl: 'https://www.youtube.com/embed/YoHD9XEInc0'
  },
  {
    id: 16,
    title: 'The Matrix',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BNzQzOTk3OTAtNDQ0Zi00ZTVkLWI0MTEtMDllZjNkYzNjNTc4L2ltYWdlXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_.jpg',
    rating: 8.7,
    year: 1999,
    genres: ['Action', 'Sci-Fi'],
    description: 'A computer hacker learns from mysterious rebels about the true nature of his reality and his role in the war against its controllers.',
    trailerUrl: 'https://www.youtube.com/embed/vKQi3bBA1y8'
  },
  {
    id: 17,
    title: 'Pulp Fiction',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BNGNhMDIzZTUtNTBlZi00MTRlLWFjM2ItYzViMjE3YzI5MjljXkEyXkFqcGdeQXVyNzkwMjQ5NzM@._V1_.jpg',
    rating: 8.9,
    year: 1994,
    genres: ['Crime', 'Drama'],
    description: 'The lives of two mob hitmen, a boxer, a gangster and his wife, and a pair of diner bandits intertwine in four tales of violence and redemption.',
    trailerUrl: 'https://www.youtube.com/embed/s7EdQ4FqbhY'
  },
  {
    id: 18,
    title: 'The Shawshank Redemption',
    imageUrl: 'https://m.media-amazon.com/images/M/MV5BNDE3ODcxYzMtY2YzZC00NmNlLWJiNDMtZDViZWM2MzIxZDYwXkEyXkFqcGdeQXVyNjAwNDUxODI@._V1_.jpg',
    rating: 9.3,
    year: 1994,
    genres: ['Drama'],
    description: 'Two imprisoned men bond over a number of years, finding solace and eventual redemption through acts of common decency.',
    trailerUrl: 'https://www.youtube.com/embed/6hB3S9bIaco'
  }
];

const genreFilters = [
  'All', 'Action', 'Comedy', 'Drama', 'Sci-Fi', 'Horror', 'Documentary'
];

const ITEMS_PER_PAGE = 8;

const BrowsePage: React.FC = () => {
  const location = useLocation();
  const [selectedGenre, setSelectedGenre] = useState<string>('All');
  const [visibleCount, setVisibleCount] = useState<number>(ITEMS_PER_PAGE);
  const [searchTerm, setSearchTerm] = useState<string>('');

  useEffect(() => {
    // Parse URL parameters
    const searchParams = new URLSearchParams(location.search);
    
    // Handle genre parameter
    const genreParam = searchParams.get('genre');
    if (genreParam && genreFilters.includes(genreParam)) {
      setSelectedGenre(genreParam);
    }
    
    // Handle search parameter
    const searchParam = searchParams.get('search');
    if (searchParam) {
      setSearchTerm(searchParam);
    } else {
      setSearchTerm(''); // Clear search when not present in URL
    }
    
    // Reset pagination when URL params change
    setVisibleCount(ITEMS_PER_PAGE);
  }, [location]);

  const handleFilterClick = (genre: string) => {
    setSelectedGenre(genre);
    setVisibleCount(ITEMS_PER_PAGE); // Reset pagination when filter changes
  };

  const handleLoadMore = () => {
    setVisibleCount(prevCount => prevCount + ITEMS_PER_PAGE);
  };

  // First filter by genre
  const genreFilteredMovies = selectedGenre === 'All' 
    ? browseMovies 
    : browseMovies.filter(movie => movie.genres.includes(selectedGenre));
  
  // Then filter by search term if present
  const filteredMovies = searchTerm
    ? genreFilteredMovies.filter(movie => 
        movie.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        movie.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        movie.genres.some(genre => genre.toLowerCase().includes(searchTerm.toLowerCase()))
      )
    : genreFilteredMovies;
  
  const moviesToShow = filteredMovies.slice(0, visibleCount);
  const hasMore = moviesToShow.length < filteredMovies.length;

  // Create a dynamic title based on search and genre
  const pageTitle = searchTerm 
    ? `Search: ${searchTerm}` 
    : selectedGenre !== 'All' 
      ? `${selectedGenre} Movies` 
      : 'Browse';

  return (
    <>
      <Title title={pageTitle} />
      <main>
        <div className="container">
          <div className="browse-header" style={{ marginTop: '120px', marginBottom: '20px' }}>
            <h1 className="section-title">
              {searchTerm ? `Results for "${searchTerm}"` : 'Browse Movies'}
            </h1>
            <div className="filter-container" style={{ display: 'flex', gap: '10px', marginBottom: '30px', flexWrap: 'wrap' }}>
              {genreFilters.map((genre, index) => (
                <button 
                  key={index} 
                  className={`category-item ${genre === selectedGenre ? 'active' : ''}`}
                  style={{ backgroundColor: genre === selectedGenre ? 'var(--primary-color)' : '' }}
                  onClick={() => handleFilterClick(genre)}
                >
                  {genre}
                </button>
              ))}
            </div>
          </div>
          
          {searchTerm && filteredMovies.length === 0 && (
            <div style={{ textAlign: 'center', padding: '50px 0' }}>
              <h3>No results found for "{searchTerm}"</h3>
              <p style={{ marginTop: '15px' }}>Try searching for a different term or browse our categories</p>
            </div>
          )}
          
          {filteredMovies.length > 0 && (
            <div className="movie-grid">
              {moviesToShow.map((movie) => (
                <MovieCard
                  key={movie.id}
                  title={movie.title}
                  imageUrl={movie.imageUrl}
                  rating={movie.rating}
                  year={movie.year}
                  description={movie.description}
                  trailerUrl={movie.trailerUrl}
                />
              ))}
            </div>
          )}

          {filteredMovies.length === 0 && !searchTerm && (
            <div style={{ textAlign: 'center', padding: '40px 0' }}>
              <h3>No movies found for this genre.</h3>
              <p>Try selecting a different genre filter.</p>
            </div>
          )}

          {hasMore && (
            <div style={{ textAlign: 'center', margin: '30px 0' }}>
              <button className="btn btn-primary" onClick={handleLoadMore}>Load More</button>
            </div>
          )}
        </div>
      </main>
    </>
  );
};

export default BrowsePage; 